import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  heightValue?: string;
  opacityValue?: string;
  hasDesigns?: boolean;
};

export const Root =styled.div`
  display: block;
`;

export const Header =styled.div`
  position: relative;
  z-index: 100;
  overflow: ${(props: IRootProps) => props.hasDesigns ? 'hidden' : ''};
  height: ${(props: IRootProps) => props.heightValue && props.hasDesigns ? props.heightValue : ''};
  opacity: ${(props: IRootProps) => props.opacityValue ? props.opacityValue : ''};
  transition: all 0.4s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Title = styled.div`
  margin: 82px 0px 0px 0px;
  font-family: Roboto;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${C.WHITE};
`;

export const Subtitle = styled.div`
  margin: 21px 0px 0px 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${C.WHITE};
`;

export const HeaderCreateButton = styled.div`
  display: flex;
  flex: 1;
  padding-top: 4px;
  padding-bottom: 28px;
  padding-left: 46px;
  padding-right: 46px;
  justify-content: flex-end;
`

export const CreateButtonContainer = styled.div`
  margin: 40px 0px 0px 0px;
  display: flex;
  justify-content: center;
`;

export const TemplatesContainer =styled.div`
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 213px;
  margin: 60px 0px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
